<template>
  <div>
    <b-modal
      :id="id_modal"
      :title="title_modal"
      :size="size_modal"
      hide-footer
      @shown="initRichTextComponent"
      @hidden="resetComponent"
      ignore-enforce-focus-selector="#sidebar-right"
      @hide="confirmClose"
    >
      <div>
        <template>
          <slot name="content_up"></slot>
        </template>
      </div>
      <!-- Se usa "kebab-case" para pasar "props" al componente de vue3-->
      <!-- Componente nuevo (Vue3) para fechas >= 2025-07-29 -->
      <!-- translate="no": la traducción del navegador reescribe el texto y Quill lo borra -->
      <klv3-rich-text-component
        v-if="show_rich_text && useNewComponent"
        ref="richTextEditor"
        translate="no"
        :content-rich-text="content_rich_text"
        @change="handleContentChange"
      ></klv3-rich-text-component>
      <!-- {{ content_rich_text }} -->
      <!-- De esta forma se envia el objeto al componente de vue3 -->
      <!-- :object-rich-text="object_rich_text" -->

      <!-- Componente anterior para fechas < 2025-07-29 -->
      <NewRichTextEditor
        v-if="show_rich_text && !useNewComponent"
        ref="oldRichTextEditor"
        :Type="Type"
        :Object="object_rich_text"
        :Text="content_rich_text"
        :permit_blank="permit_blank"
        :object_last_modification="object_rich_text"
        :show_last_modification="show_last_modification"
        @save="saveOldContent"
        @change="handleContentChange"
      >
      </NewRichTextEditor>

      <!-- Modo lista: cada línea del texto se guarda como un registro distinto -->
      <!-- <div v-if="allow_list_mode && useNewComponent" class="mt-2">
        <b-form-checkbox v-model="list_mode" switch>
          {{ $t("reusable.richTextEditor.listMode") }}
        </b-form-checkbox>
        <small class="text-muted">
          {{ $t("reusable.richTextEditor.listModeHelp") }}
        </small>
        <div
          v-if="list_mode && listEntries.length > 0"
          class="list-mode-preview mt-2 p-2"
        >
          <div class="font-weight-bold mb-1">
            {{
              $t("reusable.richTextEditor.listModeCount", {
                count: listEntries.length,
              })
            }}
          </div>
          <ol class="mb-0 pl-4">
            <li v-for="(entry, index) in listEntries" :key="index">
              {{ entry.text }}
            </li>
          </ol>
        </div>
      </div> -->

      <div class="d-flex justify-content-between mt-2" v-if="useNewComponent">
        <b-form-group
          v-if="show_last_modification == true"
          label-for="input-modification-date"
          label-cols="0"
          label-cols-sm="0"
          class="p-0 m-0 mt-2 ml-3"
        >
          <ModificationDate
            v-if="object_rich_text && !isNaN(object_rich_text.id)"
            :Information="object_rich_text"
          ></ModificationDate>
        </b-form-group>

        <!-- Solo mostrar botón para el componente nuevo -->
        <b-button
          class="ml-auto"
          v-if="useNewComponent"
          variant="primary"
          :disabled="
            (permit_blank == false && isContentEmpty) ||
            (list_mode && listEntries.length == 0)
          "
          @click="saveNewContent"
        >
          {{ $t("reusable.common.save") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
// import { toast } from "@/utils/utils";
import { splitRichTextLines } from "@/utils/utils";

export default {
  name: "ContainerRichTextKlv3",
  components: {
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
  },
  props: {
    id_modal: {
      type: String,
      required: true,
    },
    title_modal: {
      type: String,
      required: true,
    },
    size_modal: {
      type: String,
      required: true,
    },
    object_rich_text: {
      type: Object,
    },
    Type: {
      type: Object,
    },
    content_rich_text: {
      type: String,
      default: "",
    },
    show_last_modification: {
      type: Boolean,
      default: false,
    },
    permit_blank: {
      type: Boolean,
      default: true,
    },
    hide: {
      type: Function,
      default: () => {},
    },
    // Fecha de corte personalizada para determinar qué editor usar
    // Si se proporciona, sobrescribe la fecha por defecto (2025-09-10)
    // Útil para componentes donde se implementó tarde el ContainerRichTextKlv3
    // Ejemplo: ':custom_cutoff_date="'2026-01-15T00:00:00.000Z'"'
    // - Objetos creados ANTES de esta fecha → Usan NewRichTextEditor (antiguo)
    // - Objetos creados DESPUÉS de esta fecha → Usan klv3-rich-text-component (nuevo)
    custom_cutoff_date: {
      type: String,
      default: null,
    },
    // Muestra el interruptor de modo lista; en ese modo se emite "save-list" con una entrada por línea
    allow_list_mode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show_rich_text: false,
      has_content_changed: false,
      prevent_close_modal: false,
      original_content: "",
      editor_initialized: false,
      current_content: "",
      list_mode: false,
    };
  },
  computed: {
    // ...mapGetters({}),
    useNewComponent() {
      // Si no hay objeto (creando nuevo contenido), usar componente nuevo
      if (!this.object_rich_text) {
        return true;
      }
      // Si el ID no es un número válido (objeto nuevo), usar el componente nuevo
      if (isNaN(this.object_rich_text.id)) {
        return true;
      }
      // Si no hay creation_date pero tiene ID numérico (objeto existente sin fecha), usar componente antiguo
      if (!this.object_rich_text.creation_date) {
        return false;
      }
      // Si tiene creation_date, comparar con la fecha de corte
      const creationDate = new Date(this.object_rich_text.creation_date);
      // Usar fecha de corte personalizada si existe, sino usar la fecha por defecto
      const cutoffDate = this.custom_cutoff_date
        ? new Date(this.custom_cutoff_date)
        : new Date("2025-09-10T20:00:00.000Z");

      return creationDate >= cutoffDate;
    },
    isContentEmpty() {
      return !this.current_content || !this.current_content.trim();
    },
    // Vista previa de los registros que se crearán en modo lista
    listEntries() {
      if (!this.list_mode) return [];
      return splitRichTextLines(this.current_content);
    },
  },
  methods: {
    initRichTextComponent() {
      this.show_rich_text = false;
      this.original_content = this.content_rich_text;
      this.current_content = this.content_rich_text;
      this.has_content_changed = false;
      this.editor_initialized = false;
      this.$nextTick(() => {
        this.show_rich_text = true;
        // Dar tiempo para que el editor se inicialice completamente
        setTimeout(() => {
          this.editor_initialized = true;
        }, 500);
      });
    },
    resetComponent() {
      this.show_rich_text = false;
      this.has_content_changed = false;
      this.prevent_close_modal = false;
      this.editor_initialized = false;
      this.list_mode = false;
    },
    handleContentChange() {
      // Solo verificar cambios si el editor ya está completamente inicializado
      if (!this.editor_initialized) {
        return;
      }

      // Obtener el contenido actual del editor correspondiente
      let currentContent = "";
      if (this.useNewComponent && this.$refs.richTextEditor) {
        currentContent = this.$refs.richTextEditor.getContent();
      } else if (!this.useNewComponent && this.$refs.oldRichTextEditor) {
        currentContent = this.$refs.oldRichTextEditor.text || "";
      }

      // Actualizar el contenido actual para la reactividad del botón
      this.current_content = currentContent;

      // Comparar contenido actual con el original
      const hasRealChanges =
        this.normalizeContent(currentContent) !==
        this.normalizeContent(this.original_content);
      this.has_content_changed = hasRealChanges;
    },
    normalizeContent(content) {
      // Normalizar el contenido para una comparación más precisa
      if (!content) return "";

      // Remover espacios en blanco extra y normalizar HTML
      return content
        .trim()
        .replace(/\s+/g, " ")
        .replace(/>\s+</g, "><")
        .replace(/&nbsp;/g, " ");
    },
    confirmClose(bvModalEvt) {
      if (
        bvModalEvt.trigger === "headerclose" ||
        bvModalEvt.trigger === "event"
      ) {
        this.has_content_changed = false;
        this.$emit("hide");
        return;
      }
      if (!this.prevent_close_modal && this.has_content_changed) {
        bvModalEvt.preventDefault();
        this.$bvModal
          .msgBoxConfirm(
            this.$t("reusable.richTextEditor.unsavedChangesMessage"),
            {
              title: this.$t("reusable.richTextEditor.confirmationRequired"),
              size: "md",
              buttonSize: "md",
              okVariant: "warning",
              okTitle: this.$t("reusable.richTextEditor.yesClose"),
              cancelTitle: this.$t("reusable.common.cancel"),
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
              headerClass: "text-black",
              header: {
                title: this.$t("reusable.richTextEditor.confirmationRequired"),
                class: "text-center",
              },
            }
          )
          .then((value) => {
            if (value) {
              this.prevent_close_modal = true;
              this.$bvModal.hide(bvModalEvt.componentId);
              this.$nextTick(() => {
                this.has_content_changed = false;
                this.prevent_close_modal = false;
                this.$emit("hide");
              });
            }
          });
      } else {
        this.$emit("hide");
      }
    },
    saveNewContent() {
      if (this.useNewComponent) {
        if (!this.$refs.richTextEditor) return;

        // Se obtiene el content de la referencia "richTextEditor" que está definido en "defineExpose"
        const content = this.$refs.richTextEditor.getContent();
        if (this.list_mode) {
          // Una entrada por línea: el padre crea los registros en fila
          const entries = splitRichTextLines(content);
          if (entries.length == 0) return;
          this.$emit(
            "save-list",
            entries.map((entry) => entry.html)
          );
        } else {
          // Emit para el componente padre
          this.$emit("save", content);
        }
        this.has_content_changed = false;
        this.$bvModal.hide(this.id_modal);
      }
    },
    saveOldContent(object, content) {
      this.$emit("save", content);
      this.has_content_changed = false;
      this.$bvModal.hide(this.id_modal);
    },

    // Evento para cuando se trae un emit desde el proyecto de vue3 transforma el arreglo a un string
    // handleSave(event) {
    //   // El contenido viene en event.detail
    //   let content;
    //   if (event.detail) {
    //     content = Array.isArray(event.detail) ? event.detail[0] : event.detail;
    //   }
    //   this.$emit("save", content);
    //   this.$bvModal.hide(this.id_modal);
    // },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},
};
</script>

<style scoped>
.list-mode-preview {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background-color: #f8f9fa;
}
</style>
